import appContent from '@/services/content/appContent.typed';

export const getRescheduleContent = () => appContent.getAutoDeliveryContent()?.rescheduleDeliveryContent;
